import React, { useMemo, useState , useNavigate } from "react";
import axios from "axios";
import Costanti from '../constantiX';
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Checkbox } from "primereact/checkbox";
import { Column, InputText,Dialog,FileUpload,InputTextarea,Toast,Dropdown, RadioButton  } from "primereact";
import QRCode from "react-qr-code";
import { Formik } from 'formik';
import * as Yup from 'yup';
import ReactGA from 'react-ga4';
import Moment from 'moment';

import "../assets/css/badge.css";

class Config extends React.Component {

    constructor() {
        super();
        
        this.actions =[];
      
        
        this.state = {
            activePage:0,
            lista:[],
            totalRecords:0,
            first:0,
            rows:10,
            loading:true,
            visible1:false,
       };
     
       this.token=sessionStorage.getItem("ICEtoken");
       this.utente=JSON.parse(sessionStorage.getItem("utente"));
       this.state = { xcarica:'sezione', imgsrc:'', dati:[], activePage:1, totalRecords:0, pageSize:10, first:0, visible2: false,visible3: false , singolo:{},
       listaoggetto: [
        {oggetto: 'Autenticazione'},
        {oggetto: 'Gestione Azienda'},
        {oggetto: 'Gestione Notarizzazione'},
        {oggetto: 'Altro'},
        
        ]};
       
    }
  
    settaImg(){
        var testo=Costanti.UrlCallApi+'file/get/'+this.utente.aziendaid+'/certificato/'+this.certificatoid+'?'+Math.random();
        this.setState({imgsrc:testo})  
      
    }
  
    showMessage(tipo,messageError,dettaglio) {
        var icona='';
        if(tipo=='error'){icona='pi pi-times-circle';}
        if(tipo=='info'){icona='pipi-info-circle';}
        if(tipo=='success'){icona='pi pi-check-circle';}
        if(tipo=='warning'){icona='pi pi-exclamation-triangle';}
        this.toastBC.show({ severity: tipo,  life: 3000, closable: false, content: (
            <div className="flex flex-column" style={{flex: '1'}}>
                <div className="text-center">
                 <i className={icona} style={{fontSize: '3rem'}}></i>
                 <h4>{messageError}</h4>
                 <h5>{dettaglio}</h5>
                </div>
            </div>
        ) });
      }
  
     componentDidMount() {
        this.caricaDati();  
        
    }
  

    caricaDati(){
        let config = {
            headers: {
              'Authorization': 'Bearer ' + this.token
            }
          }
          this.setState({loading:true});
         var quer='aziendaid='+this.utente.aziendaid+'&tipo=2';
        axios.get(Costanti.UrlCallApi+"decodifica/all?"+quer,config)
        .then(res => {
            this.setState({dati:res.data.conta1>0?res.data.lista1[0]:{},totalRecords:res.data.conta1,loading:false})
           }).catch(error=> {
             alert(error)
        });
    } 

    caricaSingolo(id){
        let config = {
            headers: {
              'Authorization': 'Bearer ' + this.token
            }
          }
          this.setState({loading:true});
         axios.get(Costanti.UrlCallApi+"supporto/"+id,config)
        .then(res => {
            this.setState({singolo:res.data,loading:false})
            this.certificatoid=id;
            //alert(JSON.stringify(this.state.prodotti))
            //this.settaImg();
           }).catch(error=> {
             alert(error);
             this.certificatoid=0;
        });

      
    } 

 
    salva(values){
        var p=this.state.dati;

        if(this.state.totalRecords==0){
            p.id=0;
            p.status=' ';
            p.tipo=2;
            p.nome='LottoInfo';
            p.datains=1;
            p.dataupd=1;
            p.uteins=1;
            p.uteupd=1;
            p.aziendaid=this.utente.aziendaid;
            
        }
       
        let config = {
            headers: {
              'Authorization': 'Bearer ' + this.token
            }
          }
        this.setState({isSubmitting:true});
            p.valore1=values.InfoLotto;
            p.valore2=values.InfoLottoEN;
            
             axios.post(Costanti.UrlCallApi+"decodifica/salva/"+this.state.dati.id,p,config)
            .then(res => {
            this.showMessage('success','Dati salvati correttamente','');
            this.setState({isSubmitting:false});
                this.caricaDati();
        }).catch(error=> {
                this.showMessage('error','Errore nel salvataggio',error.message);
            this.setState({isSubmitting:false});
        });

    
    
    }





    
    

    render() {
    return (
        <div>
        <Toast ref={(el) => this.toastBC = el} position="bottom-center" />
        <Formik  initialValues={{ 
        InfoLotto: this.state.dati.valore1, 
        InfoLottoEN: this.state.dati.valore2, 

      }}
          enableReinitialize
          validationSchema={this.validationSchema}
          onSubmit={(values) => {
          this.salva(values);
       }}>
       {({
         values,
         errors,
         touched,
         handleChange,
         handleBlur,
         handleSubmit,
        
       }) => (
          <form onSubmit={handleSubmit}>
          <div className="grid formgrid p-fluid">
            <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
             
            <div className="field mb-1 col-12 md:col-12">
                <label htmlFor="InfoLotto" className="font-medium text-600">
                <img src="images/flag_placeholder.png" className="flag flag-it"/>Informazioni Lotto</label>
                    <InputTextarea id="InfoLotto" type="text" rows={5} autoResize value={values.InfoLotto} onChange={handleChange} onBlur={handleBlur}/>
            </div>

            <div className="field mb-1 col-12 md:col-12">
                <label htmlFor="InfoLottoEN" className="font-medium text-600">
                <img src="images/flag_placeholder.png" className="flag flag-uk"/>Informazioni Lotto EN</label>
                    <InputTextarea id="InfoLottoEN" type="text" rows={5} autoResize value={values.InfoLottoEN} onChange={handleChange} onBlur={handleBlur}/>
            </div>

     
          
        </div>


        <div className="border-top-1 surface-border pt-3">
            <Button type="submit"  icon="pi pi-save"  label="Salva" />
             </div>
        </form>
              )}
              </Formik>

        </div>     
    );
   }
};

export default Config;
